import axios from 'axios';
import { STATUS } from 'chameleon-src/constants/assessmentStatus';
import get from 'lodash/get';
import { useState } from 'react';
import { ALL_RESOURCES_STATUSES } from 'chameleon-src/components/SidebarWrapperTwoLevels/constants';

const useFetchTeacherAssignments = () => {
  const [learnositySignedRequest, setLearnositySignedRequest] = useState(null);
  const [ongoingCalls, setOngoingCalls] = useState([]);

  const loadTeacherAssignments = ({
    subject,
    status,
    resourceType,
    organizeLabelFilter,
    setData,
    setOptions = () => {},
    setLoading = () => {},
    sections,
    setHasPaperscore = () => {},
    limit,
    orderBy,
    setCachedDates = () => {},
    setReportsData = () => {},
    educationalPeriod,
    searchTerm,
    isLoading,
    isReorderInProgress,
    assessmentId,
  }) => {
    if (isLoading && ongoingCalls.length > 0) {
      ongoingCalls.forEach((call) => call.cancel());
      setOngoingCalls([]);
    }
    setLoading(true);

    if (isReorderInProgress) {
      return;
    }

    const assessmentsURL = new URL(
      `${FYM_BACKEND_URL}/assessments/api/chameleon/assessments/${subject}/`,
    );

    // the label filters take precedence in case we define both

    // Adjust the backend status name to the front-end requirements
    let adjustedStatus;
    switch (status) {
      case STATUS.ALL_RESOURCES:
        adjustedStatus = null;
        break;
      case STATUS.ASSIGNED_RESOURCES:
        adjustedStatus = STATUS.ALL_ASSIGNED;
        break;
      default:
        adjustedStatus = status;
    }

    adjustedStatus = adjustedStatus?.replace(
      STATUS.ASSIGNED_RESOURCES,
      STATUS.ALL_ASSIGNED,
    );

    const isAllResourcesPage = status
      ?.split(',')
      .every((s) => ALL_RESOURCES_STATUSES.includes(s));
    isAllResourcesPage &&
      assessmentsURL.searchParams.append('all_resources_page', '');

    searchTerm && assessmentsURL.searchParams.append('search', searchTerm);
    adjustedStatus &&
      !organizeLabelFilter &&
      assessmentsURL.searchParams.append('status', adjustedStatus);
    sections && assessmentsURL.searchParams.append('sections', sections);
    assessmentId &&
      assessmentsURL.searchParams.append('assessment_id', assessmentId);

    resourceType &&
      Object.keys(resourceType).length !== 0 &&
      assessmentsURL.searchParams.append('type', resourceType);
    organizeLabelFilter &&
      assessmentsURL.searchParams.append('labels', organizeLabelFilter);
    limit && assessmentsURL.searchParams.append('limit', limit);
    orderBy && assessmentsURL.searchParams.append('order_by', orderBy);
    educationalPeriod &&
      assessmentsURL.searchParams.append(
        'educational_period',
        educationalPeriod,
      );

    axios
      .get(assessmentsURL.href, {
        cancelToken: new axios.CancelToken((cancel) => {
          setOngoingCalls((calls) => [...calls, { cancel }]);
        }),
      })
      .then((resp) => {
        if (!resp) {
          setLoading(false);
          return;
        }
        const { data } = resp;
        const dataLearnositySignedRequest =
          data.results_learnosity_signed_request;
        setLearnositySignedRequest(dataLearnositySignedRequest);
        const dataOptions = data.options || {};
        const { has_paperscorer_answersheets: hasPaperscore } = data || {};
        setData(data.resources || []);
        setReportsData(null);
        setOptions(dataOptions);
        if (learnositySignedRequest !== dataLearnositySignedRequest) {
          setLearnositySignedRequest(dataLearnositySignedRequest);
        }
        setHasPaperscore(hasPaperscore);
        const cachedDates = (data.assessments || data.resources || []).reduce(
          (res, assessment) => {
            const assignments = get(assessment, 'assignments', []).reduce(
              (acc, assignment) => ({
                ...acc,
                [assignment.id]: {
                  starts_at: assignment.starts_at,
                  due_at: assignment.due_at,
                },
              }),
              {},
            );

            return {
              ...res,
              ...assignments,
            };
          },
          {},
        );

        setCachedDates(cachedDates);
        setLoading(false);
      });
  };

  return [loadTeacherAssignments, learnositySignedRequest];
};

export default useFetchTeacherAssignments;
